var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.13,
    height: 17.507,
    viewBox: "0 0 17.13 17.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "xlogo",
    d: "M10.195,7.413,16.572,0H15.061L9.524,6.437,5.1,0H0L6.688,9.733,0,17.507H1.511l5.848-6.8,4.671,6.8h5.1L10.195,7.413ZM8.125,9.819,7.447,8.85,2.056,1.138H4.377L8.728,7.362l.678.969,5.656,8.09H12.74l-4.615-6.6Z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlogo);
export default __webpack_public_path__ + "static/media/xlogo.5898bbbe8be2ae6c34c691478011fc15.svg";
export { ForwardRef as ReactComponent };